// src/utils/message.ts
import { ElMessage } from 'element-plus'

interface MessageOptions {
  message: string
  type?: 'success' | 'warning' | 'info' | 'error'
  duration?: number
  showClose?: boolean
}

// 封装不同类型的消息提示
export const $message = {
  success(message: string, options?: Omit<MessageOptions, 'type'>) {
    return ElMessage({
      message,
      type: 'success',
      duration: options?.duration || 3000,
      showClose: options?.showClose || false,
      ...options
    })
  },

  warning(message: string, options?: Omit<MessageOptions, 'type'>) {
    return ElMessage({
      message,
      type: 'warning',
      duration: options?.duration || 3000,
      showClose: options?.showClose || false,
      ...options
    })
  },

  info(message: string, options?: Omit<MessageOptions, 'type'>) {
    return ElMessage({
      message,
      type: 'info',
      duration: options?.duration || 3000,
      showClose: options?.showClose || false,
      ...options
    })
  },

  error(message: string, options?: Omit<MessageOptions, 'type'>) {
    return ElMessage({
      message,
      type: 'error',
      duration: options?.duration || 3000,
      showClose: options?.showClose || false,
      ...options
    })
  },

  // 通用方法
  show(options: MessageOptions) {
    return ElMessage(options)
  }
}
